import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  rowItem: {
    marginTop: 15,
    alignItems: 'center',
  },
  icon: {
    marginRight: 20,
    '& > img': {
      width: 44,
    },
  },
  sectionTitle: {
    paddingTop: '1.5rem',
    fontSize: 20,
    paddingBottom: 10,
  },
  title: {
    fontSize: 18,
    color: theme.palette.blue.efesBlue,
  },
  seeMore: {
    color: theme.palette.primary.main,
    cursor: 'pointer',
    fontSize: '0.875rem',
  },
  description: {
    textAlign: 'justify',
    marginLeft: 70,

    '& > p': {
      whiteSpace: 'pre-line',
      fontSize: 14,
      color: theme.palette.gray.efesGray,
    },
  },
}));

export default useStyles;
